
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonagpur() {



  const cardData =
  {
    keyword: 'Pune to Nagpur Cab Service',
    heading: 'AB Ghule Cabs: Pune to Nagpur Cab Service',
    headingDescription: 'AB Ghule Cabs offers reliable and comfortable Pune to Nagpur cab services. Whether you’re traveling for business, leisure, or any other purpose, our fleet of well-maintained vehicles and experienced drivers will ensure a smooth and enjoyable ride. With competitive pricing, excellent customer service, and flexible options, we make your long-distance journey hassle-free. Pune to Nagpur is approximately 700 km.',

    top: 'Top Places to Visit in Nagpur with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Deekshabhoomi",
          description: "One of the largest Buddhist stupas in India, Deekshabhoomi is a place of immense historical and religious significance, where Dr. B.R. Ambedkar converted to Buddhism. It stands as a symbol of equality and social justice and attracts numerous visitors seeking spiritual enlightenment and historical insights."
        },
        {
          title: "Futala Lake",
          description: "Futala Lake is a scenic spot, perfect for evening strolls. The lake, surrounded by greenery, is a peaceful place to relax and enjoy the natural beauty of Nagpur. The serene atmosphere and picturesque surroundings make it an ideal destination for nature lovers and those looking for tranquility."
        },
        {
          title: "Nagpur Orange Orchard",
          description: "Famous for its oranges, Nagpur offers sprawling orchards where you can witness the orange cultivation process and enjoy fresh, juicy oranges. Visitors can indulge in the unique experience of picking oranges and learn about the importance of the fruit to Nagpur's agricultural landscape."
        },
        {
          title: "Nagpur Zoo (Maharajbagh Zoo)",
          description: "This zoo, located near the city center, houses a wide variety of animals and birds and is a great place for nature lovers and families. It offers an educational experience, with opportunities to see rare species and participate in conservation efforts."
        },
        {
          title: "Shree Ganesh Mandir Tekdi",
          description: "A popular temple dedicated to Lord Ganesh, it offers a spiritual experience along with panoramic views of the city. The peaceful ambiance and breathtaking views from the temple make it a favorite spot for both devotees and tourists."
        },
        {
          title: "Raman Science Centre",
          description: "A must-visit for science enthusiasts, this interactive museum provides a deep dive into various scientific concepts with engaging exhibits and activities. It is an ideal destination for students and families interested in science, offering hands-on learning experiences."
        },
        {
          title: "Sitabuldi Fort",
          description: "A historical fort located at the heart of Nagpur, Sitabuldi Fort offers a glimpse into the city’s past and is a good spot for history buffs. The fort’s strategic location and historical significance make it an important landmark in Nagpur."
        },
        {
          title: "Zero Mile Stone",
          description: "The Zero Mile Stone marks the geographical center of India. It is a historical landmark and a great spot for photography. The monument signifies India's central position and serves as a cultural landmark."
        },
        {
          title: "Seminary Hill",
          description: "A tranquil hill with a church and great views of Nagpur, it is ideal for a peaceful retreat and enjoying the city’s landscape. Visitors can explore the hilltop, enjoy the lush surroundings, and admire panoramic views of the city."
        },
        {
          title: "Ambazari Lake",
          description: "A serene spot, Ambazari Lake offers boating opportunities and beautiful surroundings, making it a perfect location for a relaxing day out. The lake is surrounded by lush greenery, offering a peaceful environment for families and nature lovers."
        }
      ],


  services: [
    {
      "name": "Pune to Nagpur Cab Service",
      description: "Travel comfortably and safely with AB Ghule Cabs. Our Pune to Nagpur cab service ensures that your journey is smooth and hassle-free. Whether you're traveling for business or leisure, we provide reliable, timely, and affordable transportation for your trip."
    },
    {
      "name": "Pune to Nagpur Taxi Booking",
      description: "Book your taxi from Pune to Nagpur with AB Ghule Cabs. We offer easy online booking for a seamless experience. Choose from a variety of vehicles based on your preferences and travel requirements. Our experienced drivers ensure a comfortable journey."
    },
    {
      "name": "Pune to Nagpur Car Rental",
      description: "Looking for a car rental from Pune to Nagpur? AB Ghule Cabs offers a wide range of vehicles for your convenience. Whether you need a sedan, SUV, or luxury car, we have options that cater to your needs. Enjoy your trip with flexible rental options and reliable services."
    },
    {
      "name": "Pune to Nagpur One-Way Taxi",
      description: "Traveling one-way from Pune to Nagpur? AB Ghule Cabs offers affordable one-way taxi services to ensure a cost-effective and convenient journey. With our transparent pricing and no hidden charges, you can enjoy a smooth trip without any worries."
    },
    {
      "name": "Pune to Nagpur Round Trip Cabs",
      description: "AB Ghule Cabs also offers round trip taxi services for your Pune to Nagpur journey. Whether you're planning to return to Pune the same day or after a few days, we provide reliable round-trip cab services at affordable rates."
    },
    {
      "name": "Pune to Nagpur Luxury Taxi",
      description: "For a premium travel experience, choose AB Ghule Cabs' luxury taxi services. Our luxury vehicles are equipped with top-notch amenities to ensure you travel in style and comfort from Pune to Nagpur."
    },
    {
      "name": "Pune to Nagpur Cabs",
      description: "Looking for cabs from Pune to Nagpur? AB Ghule Cabs offers reliable cab services for your journey, ensuring comfort, safety, and punctuality. Our fleet of well-maintained vehicles ensures that you arrive at your destination without any hassle."
    },
    {
      "name": "Cab Pune to Nagpur",
      description: "Book your Pune to Nagpur cab with AB Ghule Cabs for a convenient and comfortable ride. We offer a variety of vehicles, from standard sedans to luxury cars, depending on your travel needs and preferences."
    },
    {
      "name": "Pune to Nagpur Cab Booking",
      description: "Booking a cab from Pune to Nagpur is easy with AB Ghule Cabs. Simply visit our website or call our helpline to reserve your taxi. We ensure prompt booking confirmation and a reliable cab service for your journey."
    },
    {
      "name": "Pune to Nagpur Cab Charges",
      description: "The charges for a cab from Pune to Nagpur vary based on the type of vehicle, distance, and duration of travel. AB Ghule Cabs offers competitive pricing with no hidden charges, so you can enjoy an affordable and transparent travel experience."
    },
    {
      "name": "Pune to Nagpur Cab Service",
      description: "For reliable cab services from Pune to Nagpur, trust AB Ghule Cabs. We provide top-quality cabs and experienced drivers to ensure your trip is smooth and hassle-free. Whether you need a one-way trip or a round trip, we have the perfect solution for you."
    },
    {
      "name": "Pune to Nagpur Taxi",
      description: "AB Ghule Cabs offers safe and reliable taxis from Pune to Nagpur. Whether you’re traveling for business or leisure, our cabs are equipped with all necessary amenities for a comfortable ride. Our drivers are experienced and ensure a timely arrival."
    },
    {
      "name": "Pune to Nagpur Taxi Fare",
      description: "The taxi fare for Pune to Nagpur varies depending on the vehicle type and duration. AB Ghule Cabs ensures competitive rates with no hidden fees, giving you the best value for your money. Get an estimate of your fare during the booking process."
    },
    {
      "name": "Pune to Amravati Cab Booking",
      description: "Traveling from Pune to Amravati? AB Ghule Cabs offers convenient and affordable cab booking services. Our reliable cabs and experienced drivers ensure a smooth and comfortable journey to Amravati."
    },
    {
      "name": "Pune to Amravati Taxi",
      description: "AB Ghule Cabs provides safe and comfortable taxis for your journey from Pune to Amravati. Our well-maintained vehicles and professional drivers ensure that you reach your destination in comfort and style."
    },
    {
      "name": "Amravati to Pune Cab Service",
      description: "Looking for a cab from Amravati to Pune? AB Ghule Cabs offers reliable and affordable taxi services for your return journey. Book your cab online or via phone, and enjoy a seamless and safe ride back to Pune."
    },
    {
      "name": "Pune to Akola Cab",
      description: "AB Ghule Cabs provides efficient and comfortable taxi services for your journey from Pune to Akola. Whether you are traveling for business or leisure, we offer reliable cabs at competitive prices to ensure a smooth ride."
    },
    {
      "name": "Pune to Akola Cab Service",
      description: "For a reliable and comfortable ride from Pune to Akola, book your cab with AB Ghule Cabs. Our professional drivers ensure timely arrivals and provide you with a smooth travel experience."
    },
    {
      "name": "Pune to Bhandara Cab",
      description: "Book your Pune to Bhandara cab with AB Ghule Cabs for a stress-free travel experience. Our cabs are comfortable and affordable, with experienced drivers who ensure your safety and convenience during the journey."
    },
    {
      "name": "Pune to Buldhana Cab",
      description: "AB Ghule Cabs offers cab services for your journey from Pune to Buldhana. Whether you’re traveling for business or leisure, we provide reliable and comfortable taxis to make your trip enjoyable and hassle-free."
    },
    {
      "name": "Pune to Buldhana Cab Service",
      description: "If you're looking for a cab service from Pune to Buldhana, AB Ghule Cabs offers affordable and reliable options. Our experienced drivers ensure a smooth ride, whether you're traveling for a short visit or a long stay."
    },
    {
      "name": "Pune to Buldhana Cab Fare",
      description: "The fare for your Pune to Buldhana cab depends on the vehicle type and duration of the trip. AB Ghule Cabs offers competitive rates for your journey, with no hidden charges, ensuring a transparent and affordable experience."
    },
    {
      "name": "Pune to Chandrapur Taxi Service",
      description: "AB Ghule Cabs provides reliable taxi services for your journey from Pune to Chandrapur. Whether you need a one-way trip or a round-trip, we ensure timely and comfortable travel with experienced drivers."
    },
    {
      "name": "Pune to Chandrapur Car Rental",
      description: "Need a car rental for your Pune to Chandrapur journey? AB Ghule Cabs offers a variety of vehicles for rent, allowing you to choose the best option based on your travel needs. Enjoy a flexible and comfortable ride."
    },
    {
      "name": "Pune to Gadchiroli Cab Service",
      description: "Travel to Gadchiroli with AB Ghule Cabs. Our comfortable and affordable taxi services ensure a pleasant journey, with well-maintained vehicles and experienced drivers who know the best routes."
    },
    {
      "name": "Pune to Gadchiroli Cab Taxi Fare",
      description: "The fare for your Pune to Gadchiroli taxi depends on the vehicle, distance, and duration. AB Ghule Cabs offers competitive prices with transparent pricing, ensuring a cost-effective and smooth journey."
    },
    {
      "name": "Pune to Nagpur Cabs Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Nagpur Cab. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Pune to Nagpur Cab Service", "-Pune to Nagpur Taxi Booking"],
    ["Pune to Nagpur Car Rental", "-Pune to Nagpur One-Way Taxi"],
    ["Pune to Nagpur Round Trip Cabs", "-Pune to Nagpur Luxury Taxi"],
    ["Pune to Nagpur Cabs", "-Cab Pune to Nagpur"],
    ["Pune to Nagpur Cab Charges", "-Pune to Nagpur Cab Service"],
    ["Pune to Nagpur Taxi", "-Pune to Nagpur Taxi Fare"],
    ["Pune to Amravati Cab Booking", "-Pune to Amravati Taxi"],
    ["Amravati to Pune Cab Service", "-Pune to Akola Cab"],
    ["Pune to Akola Cab Service", "-Pune to Bhandara Cab"],
    ["Pune to Buldhana Cab", "-Pune to Buldhana Cab Service"],
    ["Pune to Buldhana Cab Fare", "-Pune to Chandrapur Taxi Service"],
    ["Pune to Chandrapur Car Rental", "-Pune to Gadchiroli Cab Service"],
    ["Pune to Gadchiroli Cab Taxi Fare", "-Pune to Nagpur Cab Booking"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Comfortable and Safe Journey",
      WhyChoosedescription: "Travel in comfort with AB Ghule Cabs for your Pune to Nagpur trip. Our well-maintained vehicles ensure a smooth and relaxing ride. Whether you're traveling for business or leisure, our cabs offer ample space, air-conditioning, and all the necessary amenities for a comfortable experience."
    },
    {
      WhyChooseheading: "Experienced and Courteous Drivers",
      WhyChoosedescription: "Our drivers are not only highly trained but also experienced in long-distance travel. They are familiar with the Pune-Nagpur route, ensuring a safe and hassle-free journey. We prioritize your safety and comfort, making sure the journey is smooth from start to finish."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive rates for your Pune to Nagpur cab ride. Our pricing is transparent with no hidden fees, and we provide upfront quotes so you can plan your trip without any surprises. Choose from a variety of packages that fit your budget."
    },
    {
      WhyChooseheading: "Flexible Booking Options",
      WhyChoosedescription: "Whether you prefer to book your cab in advance or on short notice, we offer flexible booking options. You can easily book your cab online via our website or mobile app, or you can call our customer service to make a reservation."
    },
    {
      WhyChooseheading: "Timely and Punctual Service",
      WhyChoosedescription: "At AB Ghule Cabs, we understand the importance of punctuality. Our drivers are always on time, ensuring you reach your destination as per your schedule. We value your time and strive to offer timely pick-ups and drop-offs."
    },
    {
      WhyChooseheading: "Safe and Secure Travel",
      WhyChoosedescription: "Your safety is our priority. All our vehicles are equipped with GPS, and our drivers are trained in safety protocols to ensure a secure journey. We regularly maintain our vehicles to meet the highest safety standards, giving you peace of mind during your trip."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Our services are available round the clock to meet your travel needs. Whether you're planning a day trip or need an overnight journey, we are here to cater to your schedule. We offer flexibility with pick-up and drop-off times."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab from Pune to Nagpur?',
      answer: 'You can easily book your Pune to Nagpur cab online via our website, mobile app, or by calling our customer service. Simply provide the date, time, and pick-up details for a seamless booking experience.',
    },
    {
      id: 'FAQ2',
      question: 'How long does it take to travel from Pune to Nagpur by cab?',
      answer: 'The journey from Pune to Nagpur typically takes around 10 to 12 hours, depending on traffic conditions and the route taken. Our drivers are experienced and ensure you have a smooth and timely journey.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for the Pune to Nagpur trip?',
      answer: 'We offer a wide range of vehicles including sedans, SUVs, and luxury cars, so you can choose the one that suits your preferences and group size. All vehicles are well-maintained and equipped with essential amenities for a comfortable trip.',
    },
    {
      id: 'FAQ4',
      question: 'Are there any additional charges for the Pune to Nagpur journey?',
      answer: 'Our pricing is transparent, with no hidden charges. However, additional fees may apply for things like extra stops, waiting time, or deviations from the planned route. We inform you of any additional charges upfront.',
    },
    {
      id: 'FAQ5',
      question: 'Is the driver familiar with the Pune to Nagpur route?',
      answer: 'Yes, our drivers are experienced and familiar with the Pune to Nagpur route. They know the best routes to take to avoid traffic and ensure you have a smooth journey.',
    },
    {
      id: 'FAQ6',
      question: 'Can I modify my booking for the Pune to Nagpur trip?',
      answer: 'Yes, you can modify or cancel your booking by contacting our customer service team. We will assist you in making any necessary changes to your trip.',
    },
    {
      id: 'FAQ7',
      question: 'What is the payment method for Pune to Nagpur cabs?',
      answer: 'You can pay for your ride via cash, credit/debit card, or online payment through our app or website. We offer flexible payment options to ensure convenience.',
    },
    {
      id: 'FAQ8',
      question: 'Do you offer one-way and round-trip services for Pune to Nagpur?',
      answer: 'Yes, we offer both one-way and round-trip services for your Pune to Nagpur journey. Let us know your preferences, and we will customize the trip according to your needs.',
    },
    {
      id: 'FAQ9',
      question: 'Can I book a cab for a group of people?',
      answer: 'Absolutely! We offer vehicles that can accommodate groups of various sizes. Whether you\'re traveling solo, with family, or in a larger group, we have the right vehicle to fit your needs.',
    },
    {
      id: 'FAQ10',
      question: 'Are the vehicles equipped with safety features?',
      answer: 'Yes, all our vehicles are equipped with modern safety features including GPS tracking, first aid kits, and seat belts for every passenger to ensure your safety during the journey.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Raghav Mehta',
      feedback: 'I recently hired a cab from AB Ghule Cabs for my trip from Pune to Nagpur, and the experience was fantastic. The car was clean and well-maintained, and the driver was very professional and friendly. The journey was smooth, and we reached Nagpur right on time. Highly recommend their services!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Shweta Patil',
      feedback: 'I booked AB Ghule Cabs for a business trip to Nagpur, and I was impressed with their punctuality and excellent service. The vehicle was comfortable, and the driver was well-versed in the route. It was a smooth and stress-free ride. I will definitely use their service again for future trips.',
      rating: 5,
    },
  ];
  
  





  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Nagpur Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs</title>
  <meta name="description" content="Book your Pune to Nagpur Cabs with AB Ghule Cabs. Offering affordable, reliable taxi services and car rentals for one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune to Nagpur cab Service, Pune to Nagpur Taxi Booking, Pune to Nagpur Car Rental, Pune to Nagpur One-Way Taxi, Pune to Nagpur Round Trip Cabs, Pune to Nagpur Luxury Taxi, Pune to Nagpur Cabs, Cab Pune to Nagpur, Pune to Nagpur Cab Booking, Pune to Nagpur cab charges, Pune to Nagpur cab service, Pune to nagpur taxi, Pune to Nagpur taxi fare, pune to amravati cab booking, Pune to Amravati Taxi, Amravati to Pune Cab Service, Pune to Akola Cab, Pune to Akola Cab service, pune to bhandara cab, Pune to Buldhana Cab, pune to buldhana cab service, pune to buldhana cab fare, pune to chandrapur taxi service, pune to chandrapur car rental, pune to gadchiroli cab service, pune to gadchiroli cab taxi fare" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Nagpur Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs" />
  <meta property="og:description" content="Book your Pune to Nagpur Cabs with AB Ghule Cabs. Offering affordable, reliable taxi services and car rentals for one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-nagpur-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-nagpur-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Nagpur Cabs",
        description: "Book your Pune to Nagpur Cabs with AB Ghule Cabs. Offering affordable, reliable taxi services and car rentals for one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-nagpur-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-nagpur-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-nagpur-cabs.jpg",
        "priceRange": "₹5000 - ₹15000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-nagpur-cabs",
          "priceCurrency": "INR",
          "price": "5000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "120"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Shubham R"
            },
            "datePublished": "2024-10-20",
            "reviewBody": "I booked a one-way cab to Nagpur. The ride was very comfortable, and the driver was courteous. AB Ghule Cabs offers excellent service!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Kavita S"
            },
            "datePublished": "2024-09-15",
            "reviewBody": "Used AB Ghule Cabs for a round trip to Nagpur. Everything went smoothly. Highly recommend for outstation travel!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Nagpur Cabs",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-nagpur-cabs"
        },
        "keywords": "Pune to Nagpur cab Service, Pune to Nagpur Taxi Booking, Pune to Nagpur Car Rental, Pune to Nagpur One-Way Taxi, Pune to Nagpur Round Trip Cabs, Pune to Nagpur Luxury Taxi, Pune to Nagpur Cabs, Cab Pune to Nagpur, Pune to Nagpur Cab Booking, Pune to Nagpur cab charges, Pune to Nagpur cab service, Pune to nagpur taxi, Pune to Nagpur taxi fare, pune to amravati cab booking, Pune to Amravati Taxi, Amravati to Pune Cab Service, Pune to Akola Cab, Pune to Akola Cab service, pune to bhandara cab, Pune to Buldhana Cab, pune to buldhana cab service, pune to buldhana cab fare, pune to chandrapur taxi service, pune to chandrapur car rental, pune to gadchiroli cab service, pune to gadchiroli cab taxi fare"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/28.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetonagpur;